// extracted by mini-css-extract-plugin
export default {"SliderHolder":"Gallery_SliderHolder__d1dM0","sectionH1":"Gallery_sectionH1__SjtUU"};